angular.module('internal.mycharges',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.mycharges', {
            url: '/mycharges',
            views: {
                'content': {
                    templateUrl: 'js/internal/mycharges/mycharges.view.html',
                    controller:'MyChargesCtrl'
                }
            }
        });
        $stateProvider.state('internal.mycharges-consumption-details', {
            url: '/mycharges/consumptiondetails?period&type&pre',
            views: {
                content: {
                    templateUrl: 'js/internal/mycharges/period-details/period-details.view.html',
                    controller:'PeriodDetailsCtrl'                  
                }                
            }            
        });        
        $stateProvider.state('internal.homecharges-all-periods', {
            url: '/mycharges/home',
            views: {
                'content': {
                    templateUrl: 'js/internal/mycharges/all-periods/all-periods.view.html',
                    controller:'AllPeriodsCtrl'
                }
            }
        });
        $stateProvider.state('internal.publiccharges-all-periods', {
            url: '/mycharges/public',
            views: {
                'content': {
                    templateUrl: 'js/internal/mycharges/all-periods/all-periods.view.html',
                    controller:'AllPeriodsCtrl'
                }
            }
        });
        $stateProvider.state('internal.officecharges-all-periods', {
            url: '/mycharges/office',
            views: {
                'content': {
                    templateUrl: 'js/internal/mycharges/all-periods/all-periods.view.html',
                    controller:'AllPeriodsCtrl'
                }
            }
        });        
    }]);